import { render, staticRenderFns } from "./AddDrawingView.vue?vue&type=template&id=6bd954c4"
import script from "./AddDrawingView.vue?vue&type=script&lang=js"
export * from "./AddDrawingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports